import { useEffect, useRef } from 'react';

/**
 * Google AdSense reklam komponenti.
 *
 * Kullanım:
 *   <AdBanner adSlot="1234567890" adFormat="auto" style={{ display: 'block', width: '160px', height: '600px' }} />
 *
 * NOT: Google AdSense onayı alındıktan sonra, aşağıdaki değerleri güncelleyin:
 *   - public/index.html içindeki data-ad-client="ca-pub-2255123998253255"
 *   - Her <AdBanner> kullanımındaki adSlot prop'u
 */
export default function AdBanner({ adSlot, adFormat = 'auto', adLayout, style, className }) {
  const adRef = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle ${className || ''}`}
      style={{ display: 'block', ...style }}
      data-ad-client="ca-pub-2255123998253255"
      data-ad-slot={adSlot}
      data-ad-format={adFormat}
      {...(adLayout ? { 'data-ad-layout': adLayout } : {})}
      data-full-width-responsive="true"
    />
  );
}
